export const myDevicesTranslatePaths = {
  name: 'manage_devices.my_devices.name',
  warning: 'manage_devices.my_devices.warning',
};
